import { render, staticRenderFns } from "./model_47.vue?vue&type=template&id=e1ca63e0&scoped=true"
import script from "./model_47.vue?vue&type=script&lang=js"
export * from "./model_47.vue?vue&type=script&lang=js"
import style0 from "./model_47.vue?vue&type=style&index=0&id=e1ca63e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ca63e0",
  null
  
)

export default component.exports